import React, { useCallback, useContext, useEffect, useState, useRef } from 'react';
import { View } from 'react-native';
import WebView from 'react-native-webview';
import PropTypes from 'prop-types';
import LayoutContext from '../../contexts/Layout';
import useFormStackForm from '../../hooks/useFormStackForm';

const FormStackForm = ({ formCode, nodeTypeAlias = 'FormStackForm' }) => {
    const { layout } = useContext(LayoutContext);
    const formContent = useFormStackForm(formCode);
    const [frameHeight, setFrameHeight] = useState();
    const iframeRef = useRef();

    const buildSanitizedHtml = useCallback(() => {
        if (formContent?.length > 0) {
            return `<!DOCTYPE html><html><body>${formContent.replaceAll('href="//', 'href="https://').replaceAll('src="//', 'src="https://')}</body></html>`;
        }
        return null;
    }, [formContent]);

    useEffect(() => {
        const injectContent = () => {
            try {
                const iframe = iframeRef.current;
                const doc = iframe?.contentDocument || iframe?.contentWindow?.document;

                if (iframe && doc && formContent) {
                    const html = buildSanitizedHtml();
                    doc.open();
                    doc.write(html);
                    doc.close();
                }
            } catch (e) {
            }
        };

        if (layout.device.os.equals('web') && formContent && iframeRef.current) {
            injectContent();
        }
    }, [formContent, layout.device.os, buildSanitizedHtml]);

    if (!formContent) return null;

    return (
        <View dataSet={{ umbracoComponentName: nodeTypeAlias }}>
            {layout.device.os.equals('web') ? (
                <View style={{ flex: 1 }}>
                    <iframe
                        ref={iframeRef}
                        height={frameHeight}
                        width='100%'
                        style={{ border: 0, overflow: 'hidden' }}
                        sandbox='allow-same-origin allow-scripts allow-forms'
                        scrolling='no'
                        title='FormStack Form'
                        onLoad={() => {
                            if (!frameHeight) {
                                setFrameHeight(iframeRef.current.contentWindow.document.body.scrollHeight);
                            } else {
                                setFrameHeight(300); // form was submitted successfully and the height has changed.
                            }
                        }}
                    />
                </View>
            ) : (
                <WebView javaScriptEnabled={true} originWhitelist={['*']} source={{ html: buildSanitizedHtml() }} />
            )}
        </View>
    );
};

FormStackForm.propTypes = {
    formCode: PropTypes.string.isRequired,
    nodeTypeAlias: PropTypes.string
};

export default FormStackForm;
